<template>
  <el-dialog title="介绍关系绑定" :visible.sync="visible" @close="close">
    <el-row class="bind-box">
      <el-col :span="6" >
        <span>介绍人</span>
      </el-col>
      <el-col :span="9" >
        <span>ID：{{ this.showData.bindCrmId }}</span>
      </el-col>
      <el-col :span="9" >
        <span>昵称：{{ this.showData.bindName }}</span>
      </el-col>
    </el-row>
    <el-row class="bind-box">
      <el-col :span="6" >
        <span>被介绍人ID：</span>
      </el-col>
      <el-col :span="18" >
        <el-input class="input" v-model="crmId" placeholder="请输入被介绍人ID"></el-input>
      </el-col>
    </el-row>
    <el-row class="bind-box jm-primary">
      <el-button type="primary" @click="saveBind()">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: 'BindFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showData: {
      type: Object,
      default() {
        return {
          bindCrmId: 0,
          bindName: ''
        };
      }
    }
  },
  data() {
    return {
      crmId: ''
    };
  },
  methods: {
    async saveBind() {
      if (this.crmId === '' || this.crmId === 0) {
        this.$message.error('请输入正确的ID');
        return;
      }
      this.$http._post({
        url: '/index/student/bindUser',
        data: { crmId: this.showData.bindCrmId, bindCrmId: this.crmId, crmName: this.showData.bindName }
      }).then((res) => {
        if (res.data.result === 1) {
          this.$message.success('绑定成功');
        } else if (res.data.result === 2) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error('绑定失败');
        }
      });
      this.crmId = '';
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
    },
  }
};
</script>
<style scoped>
  .bind-box {
    line-height: 50px;
  }
  .input {
    width: 50%;
  }
</style>
